import { Power2, TweenMax } from 'gsap';
import $ from 'jquery';
import PassengerBaseClass from '../common/PassengerBaseClass';
import Util from '../../libs/util/Util';

/**
 * 航空券 検索枠 搭乗者 管理
 */
export default class PassengersClass extends PassengerBaseClass {
  constructor(_target, _parent) {
    super(_target);
    this.name = 'PassengersClass';

    this.parent = _parent;

    this.maxNum = 6;
  }

  onCreate() {
    super.onCreate();

    this.error = $('.passengers_error', this.parent);

    this.error.css({ display: 'none' });
    TweenMax.set(this.error, { y: '5%' });
  }

  onError() {
    // console.log(this.name,"onError");
    TweenMax.killTweensOf(this.error);
    let top = this.error.height() / 2;
    if (Util.isBreakpoint) {top -= this.parent.offset().top;}
    this.error.css({ top: top, 'pointer-events': 'none' });
    this.error.css({ display: 'block' });
    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.to(this.error, time, {
      opacity: 1, y: '0%', ease: ease, onComplete: () => {
        TweenMax.to(this.error, time, {
          delay: 1, y: '5%', opacity: 0, ease: ease, onComplete: () => {
            this.error.css({ display: '', opacity: '' });
          },
        });
      },
    });
  }

  onCheckSubmitError() {
    const re = super.onCheckSubmitError();

    if (!re.isError) {
      re.data = this.getPassengers();
      // console.log('----', re.data);
      const res = PassengersClass.passengersCheck(re.data);
      re.isError = res.isError;
      re.msg = res.msg;
    }
    return re;
  }

  /**
     * 搭乗者のエラーチェック
     * @param _data
     * @returns {{msg: string, isError: boolean}}
     * @constructor
     */
  static passengersCheck(_data) {
    let isError = false;
    let msg = '';
    // 八歳以下の人数
    let num_child_under_8 = 0;
    // 幼児の人数
    let num_infant = 0;
    // 2歳以下の人数
    let num_under_two = 0;

    // カテゴリ人数合計
    if (_data.child > 0) {
      for (let k in _data.ageList) {
        if (_data.ageList[k] < 8) { num_child_under_8++; }
        // 0-1歳は幼児として
        if (_data.ageList[k] < 2) { num_infant++; }
        // 2歳以下の人数
        if (_data.ageList[k] < 3) { num_under_two++; }
      }
    }
    // 幼児(座席なし)が大人の人数を上回っています
    if (num_infant > _data.adult) {
      isError = true;
      msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR1;
      return { isError: isError, msg: msg };
    }
    // 幼児(座席なし)は合計2人までしか予約できません
    if (num_infant > 2) {
      isError = true;
      msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR2;
      return { isError: isError, msg: msg };
    }
    // 子供、大人が未選択(０)の場合「搭乗人数-大人を入力して下さい（必須項目）」
    if (_data.adult === 0 && _data.child === 0) {
      isError = true;
      msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR3;
      return { isError: isError, msg: msg };
    }

    if (_data.adult === 0 && _data.child > 0) {
      // 子供の年齢が3-7歳の場合は12歳以上の搭乗者が1人以上必要
      if (num_child_under_8 - num_under_two > 0) {
        isError = true;
        // 「７歳以下のお子様の搭乗には大人(12歳以上)の同行が必要です。」
        msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR4;
        return { isError: isError, msg: msg };
      }
    }

    // 搭乗者に大人が0人、２歳以下を含む場合 「幼児(座席なし)が大人の人数を上回っています」
    if (_data.adult === 0 && num_under_two > 0) {
      isError = true;
      msg = LtikeCommon.AIRPLANE.TEXT.MODAL_PASSENGER_ERROR1;
      return { isError: isError, msg: msg };
    }

    return { isError: isError, msg: msg };
  }
}
